import { client } from "../../../Infrastructure/agent";

export const preferenceService = {
  setIsNavigationBarCollapsed: (collapsed, userId) =>
    client.post(`/main/setUserPreference`, { collapsed, userId }),

  loadPreference: (userId) => client.post("/main/loadPreference", { userId }),
  savePreference: (preference) =>
    client.post("/main/savePreference", { preference }),
};

